// No direct PHP counterpart.
// Shared JS helper for:
// - api/fuel/app/classes/controller/api/monty/groups/create.php
// - api/fuel/app/classes/controller/api/monty/groups/edit.php
// - api/fuel/app/classes/controller/api/monty/groups/delete.php
// - api/fuel/app/classes/controller/api/monty/groups/add.php
// - api/fuel/app/classes/controller/api/monty/groups/remove.php
// - api/fuel/app/classes/controller/api/monty/groups/join.php
// - api/fuel/app/classes/controller/api/monty/groups/leave.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import User from 'offline/model/user'
import Group from 'offline/model/group'

function json(data) {
	return {
		session: { offline: true },
		data: data
	}
}

export function persist(data) {
	return DB.save().then(function() {
		return json(data)
	})
}

export function unauthorised() {
	return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
}

export function invalid(code) {
	return Promise.reject({ error: code || Constants.API_ERROR_INVALID, offline: true })
}

export function currentUser(params) {
	var userId = Number(params.sessionUserId || DB.meta('sync_user_id') || 0) || 0
	return userId ? User.with_id(userId) : null
}

export function resolveGroup(params) {
	if (params.id) return Group.with_id(parseInt(params.id, 10) || 0)
	if (params.name) {
		var rows = DB.query('SELECT * FROM groups WHERE group_slug = ?', [params.name])
		return rows.length ? Group.forge(rows[0]) : null
	}
	return null
}

export function randomSlug() {
	var chars = 'abcdefghijklmnopqrstuvwxyz0123456789'
	var slug = ''
	for (var i = 0; i < 8; i++) {
		slug += chars.charAt(Math.floor(Math.random() * chars.length))
	}
	return slug
}

export function normaliseAvatar(value, currentValue) {
	if (!value) return ''
	if (value === currentValue) return value
	if (typeof value === 'string') return value
	return ''
}

export function validGroupData(data, requireSlug) {
	var name = (data.name || '').trim()
	var slug = (data.slug || '').trim().toLowerCase()
	var membership = parseInt(data.membership, 10) || 0

	if (!name || name.length > 24) return false
	if (membership !== Constants.GROUP_MEMBERSHIP_OPEN && membership !== Constants.GROUP_MEMBERSHIP_CLOSED) return false
	if (requireSlug && (!slug || slug.length > 16 || !/^[a-z0-9]+$/.test(slug))) return false
	return true
}

export function slugTaken(slug, excludeId) {
	var sql = 'SELECT group_id FROM groups WHERE lower(group_slug) = ?'
	var params = [String(slug || '').toLowerCase()]
	if (excludeId) {
		sql += ' AND group_id <> ?'
		params.push(excludeId)
	}
	return DB.query(sql, params).length > 0
}

export function touchGroup(groupId) {
	DB.run('UPDATE groups SET group_data_version = ? WHERE group_id = ?', [
		Math.floor(Date.now() / 1000),
		groupId
	])
}

export function recountGroupUsers(groupId) {
	var count = parseInt(DB.scalar('SELECT COUNT(*) FROM link_group_user WHERE group_id = ?', [groupId]), 10) || 0
	DB.run('UPDATE groups SET group_count_users = ? WHERE group_id = ?', [count, groupId])
	return count
}

export function recountUserGroups(userId) {
	var count = parseInt(DB.scalar('SELECT COUNT(*) FROM link_group_user WHERE user_id = ?', [userId]), 10) || 0
	DB.run('UPDATE user SET user_count_groups = ? WHERE user_id = ?', [count, userId])
	return count
}

export function ensureMembership(groupId, userId) {
	var existing = DB.query('SELECT link_id FROM link_group_user WHERE group_id = ? AND user_id = ?', [groupId, userId])
	if (existing.length) return parseInt(existing[0].link_id, 10) || 0

	DB.run('INSERT INTO link_group_user (group_id, user_id, link_order, daily_self, daily_perk, weekly) VALUES (?, ?, ?, ?, ?, ?)', [
		groupId,
		userId,
		0,
		0,
		0,
		0
	])
	return DB.scalar('SELECT last_insert_rowid()')
}

export function groupPayload(groupId) {
	var group = Group.with_id(groupId)
	return group ? group.to_array() : null
}

export function nextGroupId() {
	return (parseInt(DB.scalar('SELECT MAX(group_id) FROM groups'), 10) || 0) + 1
}

export function defaultSlugForUser(data, user) {
	if (user.get_upgrade()) return String(data.slug || '').trim().toLowerCase()

	var slug = randomSlug()
	while (slugTaken(slug)) slug = randomSlug()
	return slug
}
